/** Vertical landing pages: /for/:slug */
export const VERTICAL_SLUGS = ['restaurants', 'hotels', 'bars', 'cafes', 'catering'] as const;

/** Guide articles: /guides/:slug */
export const GUIDE_SLUGS = [
  'open-close',
  'staff-onboarding',
  'haccp-checks',
  'cash-closing',
  'mise-en-place',
  'multi-location',
] as const;

export type VerticalSlug = (typeof VERTICAL_SLUGS)[number];
export type GuideSlug = (typeof GUIDE_SLUGS)[number];

export function isVerticalSlug(value: string): value is VerticalSlug {
  return (VERTICAL_SLUGS as readonly string[]).includes(value);
}

export function isGuideSlug(value: string): value is GuideSlug {
  return (GUIDE_SLUGS as readonly string[]).includes(value);
}

/** Paths to include in sitemap (locale prefix applied separately). */
export function marketingContentPaths(): string[] {
  return [
    '/for',
    ...VERTICAL_SLUGS.map((slug) => `/for/${slug}`),
    '/guides',
    ...GUIDE_SLUGS.map((slug) => `/guides/${slug}`),
  ];
}



// WEBPACK FOOTER //
// ./src/content/marketingRoutes.ts